export default __webpack_public_path__ + "static/media/Szymon_prof.19ed32af.jpg";